import { DEFAULT_CURRENCY } from "../constants";

/**
 * Populates account currencies for accounts that don't have currencies specified
 * This ensures risk score calculation APIs receive proper currency information
 *
 * @param {Array} accountInfo - Array of account objects
 * @returns {Array} Array of account objects with populated currency information
 */
export const populateAccountCurrencies = accountInfo => {
  if (!Array.isArray(accountInfo)) {
    return accountInfo;
  }
  return accountInfo.map(account => {
    // Handle null or undefined account objects
    if (!account || typeof account !== "object") {
      return account;
    }

    // Check if accountCurrencies exists and has valid values
    const hasValidCurrencies =
      account.accountCurrencies &&
      Array.isArray(account.accountCurrencies) &&
      account.accountCurrencies.length > 0;

    return {
      ...account,
      accountCurrencies: hasValidCurrencies ? account.accountCurrencies : [DEFAULT_CURRENCY]
    };
  });
};

export default populateAccountCurrencies;
